module.exports = __webpack_public_path__ + "static/media/who-is.11ec8678.svg";